import styled from 'styled-components'

const QuestionText = styled.pre`
  border: solid 5px #FF3B26;
  border-width: 0 0 0 5px;
  border-radius: 0;
  padding-left: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  font-weight: bold;
  font-family: sans-serif;
  white-space: pre-wrap;
  word-break: break-word;
  flex-grow: 1;
  background-color: #fff;
`

export default QuestionText
